<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="场站名称：">
            <el-select style="width: 230px;" v-model="formInline.stationId" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="枪类型：">
            <el-select style="width: 100px;" v-model="formInline.type" filterable placeholder="请选择">
                <el-option
                v-for="item in gunOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="工作状态：">
            <el-select style="width: 100px;" v-model="formInline.workState" filterable placeholder="请选择">
                <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="primary" @click="exportData">导出二维码</el-button>
        </el-form-item>
    </el-form>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="所属场站" width="180" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.stationName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="充电桩">
        <template #default="scope">
          <div>
            <span>{{scope.row.pileIndex}}号桩</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="60" label="名称">
        <template #default="scope">
          <div>
            <span>{{scope.row.name}}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="序号">
        <template #default="scope">
          <div>
            <span>{{scope.row.gunIndex}}</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="ID" width="200" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{scope.row.connectorId}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="120">
        <template #default="scope">
          <div>
            <span>{{typeFilter(scope.row.type)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="网络状态">
        <template #default="scope">
          <div>
            <span>{{networkFilter(scope.row.networkState)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="工作状态">
        <template #default="scope">
          <div>
            <span>{{workFilter(scope.row.workState)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="插拔状态">
        <template #default="scope">
          <div>
            <span>{{plugFilter(scope.row.plugState)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="电子锁状态" min-width="150">
        <template #default="scope">
          <div>
            <span>{{lockFilter(scope.row.lockState)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="辅助电压">
        <template #default="scope">
          <div>
            <span>{{auxiFilter(scope.row.auxiliaryVoltage)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最大输出功率(KW)" min-width="150">
        <template #default="scope">
          <div>
            <span>{{scope.row.outputPowerMax}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="220">
        <template #default="scope">
          <div>
            <span>{{scope.row.createTime}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="scope">
          <el-button type="success" size="small" @click="previewQrCode(scope.$index, scope.row)">
            预览二维码
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
    
    <!-- 图片预览 -->
    <el-dialog v-model="dialogVisible" width="430">
        <div style="width: 400px;">
            <img width="100%" :src="dialogImageUrl" alt="">
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ChargeGunList',
    data() {
        return {
            dialogImageUrl: '', //图片地址
            dialogVisible: false, //图片预览
            formInline: { //表单
                stationId: '', //场站名称
                type: '', //枪类型
                workState: '', //工作状态
            }, 
            stationOptions: this.$store.state.stationList, //场站列表
            gunOptions: [ //枪类型
                { value: '', label: '全部' },
                { value: '1', label: '交流' },
                { value: '2', label: '直流' },
            ],
            statusOptions: [ //工作状态
                { value: '', label: '全部' },
                { value: '0', label: '空闲' },
                { value: '1', label: '充电中' },
                { value: '2', label: '故障' },
                { value: '3', label: '被禁用' },
                { value: '4', label: '排队中' },
                { value: '5', label: '被预约' },
            ],
            tableData: [], //列表数据
            total: 0, //总条数
            currentPage: 1, //当前页
            pageSize: 10, //每页显示条数
        }  
    },
    computed: {
        filteredMessage() {
            // 这里可以实现类似过滤器的转换逻辑
        } 
    },
    setup() {
        function typeFilter(value){
            //过滤函数
            if(value=='1'){
                return '交流'
            }else if(value=='2'){
                return '直流'
            }else if(value=='3'){
                return '直交一体'
            }else{
                return '其他'
            }
        } 
        function lockFilter(value){
            //过滤函数
            if(value=='1'){
                return '无锁'
            }else if(value=='2'){
                return '解锁'
            }else if(value=='3'){
                return '锁止'
            }else{
                return '其他'
            }
        }
        function auxiFilter(value){
            //过滤函数
            if(value=='1'){
                return '12V'
            }else if(value=='2'){
                return '24V'
            }else if(value=='3'){
                return '自适应'
            }else{
                return '其他'
            }
        }
        function plugFilter(value){
            //过滤函数
            if(value=='0'){
                return '未插枪'
            }else if(value=='1'){
                return '已插枪'
            }else{
                return '其他'
            }
        }
        function workFilter(value){
            //过滤函数
            if(value=='0'){
                return '空闲'
            }else if(value=='1'){
                return '充电中'
            }else if(value=='2'){
                return '故障'
            }else if(value=='3'){
                return '被禁用'
            }else if(value=='4'){
                return '排队中'
            }else if(value=='5'){
                return '被预约'
            }else if(value=='6'){
                return '离线'
            }else{
                return '其他'
            }
        }
        function networkFilter(value){
            //过滤函数
            if(value==0){
                return '离线'
            }else if(value==1){
                return '在线'
            }else{
                return '--'
            }
        }
        return { typeFilter,lockFilter,auxiFilter,plugFilter,workFilter,networkFilter }
    },
    mounted() {
        this.getList(); //获取列表
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.stationOptions = newVal;
                }
            },
            immediate: true
        }
    },
    methods:{
        handleSizeChange (val) { //每页显示条数
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) { //当前页
            this.currentPage = val;
            this.getList(); //获取列表
        },
        previewQrCode(index, row){
            //预览二维码
            let that = this;
            that.dialogImageUrl = row.qrCode; //图片地址 
            that.dialogVisible = true; //图片预览
        },
        getList(){
            //获取列表
            let that = this;
            let param = {};
            param.page = this.currentPage;
            param.pageSize = this.pageSize;
            Object.keys(this.formInline).forEach(key => {
                param[key] = this.formInline[key];
            });
            that.$axios.post(that.$store.state.platformApi+"gun/list",JSON.stringify(param)).then(result => {
                if(result.code==200){
                    that.tableData = result.data.records; 
                    that.total = result.data.total;
                    // console.log(that.tableData);
                }
            })
        },
        exportData(){
            //导出
            let that = this;
            // 将搜索条件作为参数传递给后端
            const exportParams = {
                stationId: that.formInline.stationId,
                type: that.formInline.type,
                workState: that.formInline.workState
            };
            this.$axios.post(that.$store.state.platformApi+"gun/export", exportParams, {responseType: 'blob'}).then(result => {
                // console.log(result);
            })
        }
    }  
}
</script>